import React from 'react';
import { Lightbulb, CheckCircle2, ArrowRight } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-12 bg-navy-800 relative overflow-hidden" data-id="element-227">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" data-id="element-228"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" data-id="element-229"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-230">
        <div className="text-center mb-10" data-id="element-231">
          <h2 className="text-3xl md:text-4xl font-heading font-black text-white mb-4 flex items-center justify-center gap-3" data-id="element-232">
            <Lightbulb className="w-10 h-10 text-gold-400" data-id="element-233" />
            El cambio que lo transforma todo
          </h2>
          <p className="text-xl text-slate-300" data-id="element-234">
            Cuando tenés un sistema… Todo cambia. De verdad.
          </p>
        </div>

        <div className="bg-navy-900 rounded-2xl p-6 md:p-8 border border-navy-700 shadow-xl mb-10" data-id="element-235">
          <h3 className="text-xl font-bold text-white mb-6 text-center" data-id="element-236">
            Pasás de:
          </h3>

          <div className="grid md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-8" data-id="element-237">
            <div className="space-y-3" data-id="element-238">
              <div className="flex items-center gap-3 text-slate-400 bg-navy-950/50 p-3 rounded-lg" data-id="element-239">
                <span className="text-red-500 font-bold" data-id="element-240">❌</span>
                <span className="line-through" data-id="element-241">Hacer todo vos</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 bg-navy-950/50 p-3 rounded-lg" data-id="element-242">
                <span className="text-red-500 font-bold" data-id="element-243">❌</span>
                <span className="line-through" data-id="element-244">Repetir constantemente</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 bg-navy-950/50 p-3 rounded-lg" data-id="element-245">
                <span className="text-red-500 font-bold" data-id="element-246">❌</span>
                <span className="line-through" data-id="element-247">Reaccionar</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400 bg-navy-950/50 p-3 rounded-lg" data-id="element-248">
                <span className="text-red-500 font-bold" data-id="element-249">❌</span>
                <span className="line-through" data-id="element-250">Vivir en caos</span>
              </div>
            </div>

            <div className="hidden md:flex flex-col justify-center items-center text-gold-500/30" data-id="element-251">
              <ArrowRight className="w-12 h-12" data-id="element-252" />
            </div>

            <div className="space-y-3" data-id="element-253">
              <div className="flex items-center gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-3 rounded-lg" data-id="element-254">
                <CheckCircle2 className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-255" />
                <span className="font-bold" data-id="element-256">Dirigir con claridad</span>
              </div>
              <div className="flex items-center gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-3 rounded-lg" data-id="element-257">
                <CheckCircle2 className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-258" />
                <span className="font-bold" data-id="element-259">Tener procesos definidos</span>
              </div>
              <div className="flex items-center gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-3 rounded-lg" data-id="element-260">
                <CheckCircle2 className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-261" />
                <span className="font-bold" data-id="element-262">Anticiparte</span>
              </div>
              <div className="flex items-center gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-3 rounded-lg" data-id="element-263">
                <CheckCircle2 className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-264" />
                <span className="font-bold" data-id="element-265">Operar con control</span>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto space-y-4 text-lg text-slate-300 text-center mb-10" data-id="element-266">
          <p className="text-2xl font-heading font-bold text-white" data-id="element-267">
            Imaginá esto por un segundo
          </p>
          <p data-id="element-268">
            Tu tripulación sabe exactamente qué hacer. Sin que tengas que
            explicarlo cada vez.
          </p>
          <p data-id="element-269">Las tareas fluyen. El barco funciona como un equipo.</p>
          <p data-id="element-270">Vos no corrés.</p>
          <p className="text-3xl font-black text-gold-400 py-2" data-id="element-271">
            👉 Vos dirigís.
          </p>
          <p data-id="element-272">Y los clientes lo sienten.</p>
          <p data-id="element-273">Porque cuando hay orden…</p>

          <div className="flex flex-wrap justify-center gap-3 py-4" data-id="element-274">
            <span className="bg-navy-900 px-4 py-2 rounded-full border border-navy-700 text-white font-medium" data-id="element-275">
              👉 Hay profesionalismo.
            </span>
            <span className="bg-navy-900 px-4 py-2 rounded-full border border-navy-700 text-white font-medium" data-id="element-276">
              👉 Hay consistencia.
            </span>
            <span className="bg-navy-900 px-4 py-2 rounded-full border border-navy-700 text-white font-medium" data-id="element-277">
              👉 Hay mejor experiencia.
            </span>
            <span className="bg-navy-900 px-4 py-2 rounded-full border border-navy-700 text-white font-medium" data-id="element-278">
              👉 Hay más valor.
            </span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-navy-900 to-navy-950 rounded-2xl p-6 md:p-8 border border-gold-500/30 text-center shadow-2xl" data-id="element-279">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3" data-id="element-280">
            ⚓ Existe un sistema para lograr esto
          </h2>
          <p className="text-lg text-slate-300 mb-4" data-id="element-281">
            Y fue creado específicamente para este problema.
          </p>
          <p className="text-slate-400 mb-1" data-id="element-282">Se llama:</p>
          <h3 className="text-3xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-yellow-200 mb-8" data-id="element-283">
            CHARTER COMMAND SYSTEM™
          </h3>

          <div className="text-left max-w-2xl mx-auto" data-id="element-284">
            <h4 className="text-lg font-bold text-white mb-4 flex items-center gap-2" data-id="element-285">
              <span data-id="element-286">🔧</span> ¿Qué es Charter Command System™?
            </h4>
            <p className="text-slate-300 mb-4" data-id="element-287">
              Es un sistema práctico, directo y aplicable desde el primer día.
            </p>
            <p className="text-slate-300 mb-3" data-id="element-288">Diseñado para que puedas:</p>
            <ul className="grid sm:grid-cols-2 gap-3 mb-6" data-id="element-289">
              <li className="flex items-center gap-2 text-slate-200" data-id="element-290">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-291"></div>{' '}
                Estructurar tu operación
              </li>
              <li className="flex items-center gap-2 text-slate-200" data-id="element-292">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-293"></div>{' '}
                Organizar tu tripulación
              </li>
              <li className="flex items-center gap-2 text-slate-200" data-id="element-294">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-295"></div>{' '}
                Definir tareas claras
              </li>
              <li className="flex items-center gap-2 text-slate-200" data-id="element-296">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-297"></div>{' '}
                Delegar sin perder control
              </li>
              <li className="flex items-center gap-2 text-slate-200" data-id="element-298">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-299"></div>{' '}
                Eliminar el caos operativo
              </li>
            </ul>

            <div className="bg-navy-800/50 p-4 rounded-xl border-l-4 border-gold-500 mb-6" data-id="element-300">
              <p className="text-slate-300" data-id="element-301">No es teoría.</p>
              <p className="text-xl font-bold text-white mt-2" data-id="element-302">
                👉 Es implementación real.
              </p>
            </div>

            <div className="text-center" data-id="element-303">
              <CTAButton data-id="element-304" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}